export default __webpack_public_path__ + "static/media/service-not-available.184d9c80.svg";